import axios from 'axios';
import cookie from 'react-cookies';

import { isQiyeweixin } from "./components/ShareUtils";

// ww42250e5796a5283a 新动传媒
// wx048a740b5cdc1c0d 云宝
const redirect_uri = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww42250e5796a5283a&redirect_uri=' +
    encodeURI(process.env.MAIN_HOST) + '&response_type=code&scope=snsapi_base#wechat_redirect';

function clearToken() {
    cookie.remove(process.env.TOKEN_KEY, { path: '/' });
    if (isQiyeweixin()) {
        window.location.href = redirect_uri;
    } else {
        window.location.href = process.env.MAIN_HOST + "pclogin";
    }
}

export function _getLinkedDataForm(sid, page, pageSize, definitionId, fieldId, searchKey) {
    const params = { "sid": sid, "page": page, "pageSize": pageSize, "definitionId": definitionId, "fieldId": fieldId, "searchKey": searchKey };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/getLinkedDataForm.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _ocrVatInvoice(sid, fileUrlList) {
    const params = { "sid": sid, "fileUrlList": fileUrlList };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/ocr/vatInvoice.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _uploadByWx(sid, serverIds) {
    const params = { "sid": sid, "serverIds": serverIds };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/file/uploadByWx.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _refreshFieldValue(sid, formId, fieldId, userDepart, reqParams) {
    const params = { "sid": sid, "formId": formId, "fieldId": fieldId, "userDepart": userDepart, "reqParams": reqParams };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/refresh/fieldValue.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _listTag(sid) {
    const params = { "sid": sid };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/tag/list.api', JSON.stringify(params))
            .then((response) => {
                resolve(response.data);
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _listFormGroup(sid) {
    const params = { "sid": sid };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/listFormGroup.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _saveCommonForm(sid, definitionId, isCommon) {
    const params = { "sid": sid, "definitionId": definitionId, "isCommon": isCommon };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/saveCommonForm.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _updateCommonFormSort(sid, commonForms) {
    const params = { "sid": sid, "commonForms": commonForms };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/updateCommonFormSort.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _listCommonForm(sid) {
    const params = { "sid": sid };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/listCommonForm.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _listForm(sid, groupId) {
    const params = { "sid": sid, "groupId": groupId };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/listForm.api', JSON.stringify(params))
            .then((response) => {
                resolve(response.data);
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _getForm(sid, formId) {
    const params = { "sid": sid, "formId": formId };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/getForm.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

// 获取部门职员
export function _getMember(sid, departmentId, status, page, pageSize) {
    const params = { "sid": sid, "departmentId": departmentId, "status": status, "page": page, "pageSize": pageSize };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/staff/list.api', JSON.stringify(params))
            .then((response) => {
                resolve(response.data);
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _saveForm(sid, formId, status, formFields, formDataId, transactorCC, userDepart) {
    if (!formDataId) {
        formDataId = '';
    }
    const params = {
        "sid": sid,
        "formId": formId,
        "status": status,
        "formFields": formFields,
        "formDataId": formDataId,
        "transactorCC": transactorCC,
    };
    if (userDepart && userDepart > 0) {
        params.userDepart = userDepart;
    }
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/submitFormData.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _getDataFormCount(sid, type, formStatus) {
    let params = { "sid": sid, "type": type };
    if (formStatus) {
        params.formStatus = formStatus;
    }
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/getDataFormCount.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _getDataForm(sid, formDataId) {
    const params = { "sid": sid, "formDataId": formDataId };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/getDataForm.api', JSON.stringify(params))
            .then((response) => {
                resolve(response.data);
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

// 获取公司部门
export function _getDepartmen(sid, departmentId) {
    const params = { "sid": sid, "departmentId": departmentId };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/staff/listDepartment.api', JSON.stringify(params))
            .then((response) => {
                resolve(response.data);
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _getDataFormList(sid, formStatus, page, pageSize, searchType, searchKey) {
    if (!page || page < 0) {
        page = 0;
    }
    const params = { "sid": sid, "status": formStatus, "page": page, "pageSize": pageSize, "searchType": searchType, "searchKey": searchKey };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/getDataFormList.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _getDataFormListByFrom(sid, definitionId, page, pageSize, searchType, searchKey) {
    if (!page || page < 0) {
        page = 0;
    }
    const params = { "sid": sid, "definitionId": definitionId, "page": page, "pageSize": pageSize, "searchType": searchType, "searchKey": searchKey };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/getDataFormListByFrom.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

// 查询成员
export function _searchMember(sid, searchKey, status) {
    const params = { "sid": sid, "searchKey": searchKey, "status": status };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/staff/search.api', JSON.stringify(params))
            .then((response) => {
                resolve(response.data);
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _dropDataForm(sid, formDataId) {
    const params = { "sid": sid, "formDataId": formDataId };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/dropDataForm.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _copySubmitForm(sid, formDataId) {
    const params = { "sid": sid, "formDataId": formDataId };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/copySubmit.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _getHandleDataFormList(sid, status, page, pageSize, searchType, searchKey) {
    if (!page || page < 0) {
        page = 0;
    }
    const params = { "sid": sid, "status": status, "page": page, "pageSize": pageSize, "searchType": searchType, "searchKey": searchKey };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/getHandleDataFormList.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _getCCDataFormList(sid, formStatus, page, pageSize, searchType, searchKey) {
    if (!page || page < 0) {
        page = 0;
    }
    const params = { "sid": sid, "status": formStatus, "page": page, "pageSize": pageSize, "searchType": searchType, "searchKey": searchKey };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/getCCDataFormList.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _getRelatedDataFormList(sid, formStatus, page, pageSize, searchType, searchKey) {
    if (!page || page < 0) {
        page = 0;
    }
    const params = { "sid": sid, "status": formStatus, "page": page, "pageSize": pageSize, "searchType": searchType, "searchKey": searchKey };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/getRelatedDataFormList.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _getNextFlowNodes(sid, formDataId, currentNodeId) {
    const params = { "sid": sid, "formDataId": formDataId, "currentNodeId": currentNodeId, };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/getNextFlowNodes.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _getPreFlowNodes(sid, formDataId, currentNodeId) {
    const params = { "sid": sid, "formDataId": formDataId, "currentNodeId": currentNodeId, };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/getPreFlowNodes.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _approveFormData(sid, formDataId, approveDesc, actionType,
    backFlowNode, currentDataFlowNodeId, exFields, signType, signUsers, up, formFields) {
    const params = {
        "sid": sid,
        "formDataId": formDataId,
        "approveDesc": approveDesc,
        "actionType": actionType,
        "backFlowNode": backFlowNode,
        "currentDataFlowNodeId": currentDataFlowNodeId,
        "exFields": exFields,
        "signType": signType,
        "signUsers": signUsers,
        "up": up,
        "formFields": formFields,
    };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/approve.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _loginByCode(code) {
    const params = { "code": code, };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/loginByCode.api', JSON.stringify(params))
            .then((response) => {
                resolve(response.data);
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _loginByUserid(sid, userid) {
    const params = { "sid": sid, "userid": userid, };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/loginByUserid.api', JSON.stringify(params))
            .then((response) => {
                resolve(response.data);
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _undoFormData(sid, formDataId) {
    const params = { "sid": sid, "formDataId": formDataId, };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/undo.api', JSON.stringify(params))
            .then((response) => {
                resolve(response.data);
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _deleteComment(sid, commentId) {
    const params = { "sid": sid, "commentId": commentId };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/deleteComment.api', JSON.stringify(params))
            .then((response) => {
                resolve(response.data);
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _addComment(sid, commentContent, formDataId, atMembers, commentImage, commentFile) {
    const params = {
        "sid": sid,
        "commentContent": commentContent,
        "formDataId": formDataId,
        "atMembers": atMembers,
        "commentImage": commentImage,
        "commentFile": commentFile
    };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/addComment.api', JSON.stringify(params))
            .then((response) => {
                resolve(response.data);
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}

export function _printDataForm(formDataId) {
    const params = { "formDataId": formDataId };
    return new Promise((resolve, reject) => {
        axios.post(process.env.API_HOST + '/m/printDataForm.api', JSON.stringify(params))
            .then((response) => {
                if (response.data.code === 9999) {
                    clearToken();
                } else {
                    resolve(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                resolve(error);
            })
    });
}